import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import UserService from "../../services/UserService";

let initialState = {
    teachers: [],
    isLoading: false,
    hasMore: false,
    error: null,
}
export const getAllTeachersPageable = createAsyncThunk(
    'getAllTeachersPageable',
    async ({ page, limit, isGroupsNeeded }, {getState, rejectWithValue, dispatch}) => {
        try {
            return await UserService.getTeachers(page, limit, isGroupsNeeded);
        } catch (error) {
            return rejectWithValue(error?.response?.data);
        }
    },
);

const teachersListSlice = createSlice({
    name: 'teachersListSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getAllTeachersPageable.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(getAllTeachersPageable.fulfilled, (state, action) => {
                state.isLoading = false;
                state.teachers = action.payload.data;
                state.hasMore = action.payload.hasMore;
            })
            .addCase(getAllTeachersPageable.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
                state.teachers = [];
                state.hasMore = false;
            })
    }
});

export const {} = teachersListSlice.actions;

export default teachersListSlice.reducer;